import angular from 'angular';

angular.module('cloudX').directive('fileDropzone', [
  'flySvc',
  '$timeout',
  function(flySvc, $timeout) {
    return {
      restrict: 'A',
      scope: {
        showInput: '@',
        base64: '@',
        upload: '&',
      },
      link: function(scope, element, attrs, ctrl) {
        var draggingClass = 'dragover';
        var inputId = 'fileInput' + Math.random();
        var inputWrapper = angular.element(
          '<div><label for="' +
            inputId +
            '" data-translate="Select file for upload"></label></div>',
        );
        var input = angular.element('<input id="' + inputId + '" type="file" />');
        input.addClass('form-control');
        inputWrapper.append(input);

        var canDrag = (function() {
          var div = document.createElement('div');
          return 'draggable' in div || ('ondragstart' in div && 'ondrop' in div);
        })();
        var isAdvancedUpload = (function() {
          return 'FormData' in window && 'FileReader' in window;
        })();
        scope.showInput = scope.showInput === 'true';
        scope.base64 = scope.base64 === 'true';
        /*
        Hack to stop flickering.
        DragLeave event is triggered when hovering over child elements.
        Adding small delay before removing class from element
        */
        const dragging = {
          timeout: null,
        };
        var processDragOverOrEnter = function(event) {
          if (event != null) {
            //Cancel DragLeave event
            if (dragging.timeout) clearTimeout(dragging.timeout);

            var dataTransfer = event.dataTransfer || event.originalEvent.dataTransfer;
            if (!dataTransfer || !dataTransfer.items) return false;
            if (attrs.disableDrop === 'true') {
              event.preventDefault();
              dataTransfer.effectAllowed = 'none';
              dataTransfer.dropEffect = 'none';
              return false;
            }
            var validType = false;
            for (var i = 0; i < dataTransfer.items.length; i++)
              if (
                dataTransfer.items[i].type !== 'undefined' &&
                isTypeValid(dataTransfer.items[i].type, false)
              )
                validType = true;
            if (!validType) {
              dataTransfer.dropEffect = 'none';
              return false;
            }
            event.preventDefault();

            if (
              (dataTransfer.types.contains && dataTransfer.types.contains('Files')) ||
              (dataTransfer.types.indexOf && dataTransfer.types.indexOf('Files') >= 0)
            ) {
              dataTransfer.effectAllowed = 'copy';
              dataTransfer.dropEffect = 'copy';
              element.addClass(draggingClass);
            } else {
              dataTransfer.effectAllowed = 'none';
              dataTransfer.dropEffect = 'none';
            }
          }
          return false;
        };
        var processDragLeaveOrEnd = function(event) {
          //Delay event
          dragging.timeout = window.setTimeout(function() {
            element.removeClass(draggingClass);
            dragging.timeout = null;
          }, 200);
          return false;
        };
        var validMimeTypes = attrs.fileDropzone;
        if (validMimeTypes) {
          input.attr('accept', validMimeTypes.replace(/[\[\]]/g, ''));
        }

        var checkSize = function(size) {
          var ref;
          if (
            (ref = attrs.maxFileSize) === void 0 ||
            ref === '' ||
            size / 1024 / 1024 < attrs.maxFileSize
          ) {
            return true;
          } else {
            $timeout(function() {
              flySvc.error(18, [
                attrs.maxFileSize + ' MB',
                (size / 1024 / 1024).toFixed(2) + ' MB',
              ]);
            }, 0);
            return false;
          }
        };
        var isTypeValid = function(type, showAlert) {
          if (showAlert === void 0) showAlert = true;
          if (
            validMimeTypes === void 0 ||
            validMimeTypes === '' ||
            validMimeTypes.indexOf(type) > -1
          ) {
            return true;
          } else {
            if (showAlert)
              $timeout(function() {
                flySvc.error(2022, [attrs.fileTypeDesc ? attrs.fileTypeDesc : validMimeTypes]);
              }, 0);
            return false;
          }
        };
        var setFile = function(file) {
          var reader = new FileReader();
          reader.onload = function(evt) {
            if (checkSize(file.size) && isTypeValid(file.type)) {
              $timeout(function() {
                scope.upload({
                  file: {
                    name: file.name,
                    data: scope.base64 ? evt.target.result : file,
                    size: file.size,
                    type: file.type,
                  },
                });
              }, 0);
            }
          };
          reader.readAsDataURL(file);
        };
        var setFiles = function(files) {
          if (!files.length) return;
          if (typeof attrs.allowMultiple === 'undefined' || attrs.allowMultiple === 'false')
            setFile(files[0]);
          else for (var i = 0; i < files.length; i++) setFile(files[i]);
        };

        if (scope.showInput || !canDrag) {
          element.append(inputWrapper);
          input.bind('change', function(event) {
            if (event && event.target) {
              if (event.target.files) setFiles(event.target.files);
              event.target.value = '';
            }
          });
        }
        if (canDrag) {
          element.bind('dragover', processDragOverOrEnter);

          element.bind('dragenter', processDragOverOrEnter);
          element.bind('dragleave', processDragLeaveOrEnd);
          element.bind('dragend', processDragLeaveOrEnd);
          element.bind('drop', function(event) {
            element.removeClass(draggingClass);
            if (event != null) {
              var dataTransfer = event.dataTransfer || event.originalEvent.dataTransfer;
              if (!dataTransfer) return false;
              if (attrs.disableDrop === 'true') {
                event.preventDefault();
                return false;
              }
              event.preventDefault();
              if (
                !(
                  (dataTransfer.types.contains && dataTransfer.types.contains('Files')) ||
                  (dataTransfer.types.indexOf && dataTransfer.types.indexOf('Files') >= 0)
                )
              )
                return false;
              if (dataTransfer.files.length <= 0) return false;
              setFiles(dataTransfer.files);
            }
            return false;
          });
        }
      },
    };
  },
]);
